<template>
  <div class="edit-modal-window edit-list-component" :class="{mobile : isMobileDevice}">
    <div class="container">
      <div class="header">
        <span class="edit-modal-window-title clickable" @click="copyTitleToClipboard()">
          Редактирование списка
          <i>{{id}}</i>
        </span>
        <font-awesome-icon class="close-icon" icon="window-close" size="lg" @click="cancel()" />
      </div>
      <EditListContent class="list-content" :list="list" @cancel="cancel()" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import EditListContent from "./EditListContent";
import urlManager from "../../../common/urls";
import SimpleClipboard from "../../../common/simpleClipboard";
import clickHelper from "../../../common/clickHelper";

export default {
  name: "EditList",
  props: ["list"],
  components: { EditListContent },
  computed: {
    ...mapGetters(["isMobileDevice"]),
    id() {
      if (!this.list) return 0;

      return this.list.id;
    }
  },
  methods: {
    copyTitleToClipboard() {
      if (!this.list) return;

      if (!clickHelper.isRealClick()) return;

      new SimpleClipboard().copyText(urlManager.getListUrl(this.list));
      this.$snotify.success(`Ссылка на список ${this.list.id} скопирована`, {
        timeout: 1000,
        showProgressBar: false
      });
    },
    cancel() {
      this.$emit("cancel");
    }
  },
  data() {
    return {};
  }
};
</script>

<style lang="postcss">
.edit-list-component {
  .mobile {
    overflow-y: auto;
  }

  .container {
    margin: 0 0.5em;
    border-radius: 10px;
    height: 100%;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    grid-gap: 0.5em;
    grid-template-areas:
      "header"
      "list-content";
  }

  .header {
    margin-top: 0.5em;
    grid-area: header;
    display: grid;
    grid-template-rows: 1fr;
    grid-template-columns: 1fr 2em;
    grid-template-areas: "tabs close";
  }

  .active {
    background: #4caf50;
    font-weight: bold;
  }

  .tab-content {
    grid-area: tabcontent;
    padding: 0.5em;
  }

  .tab-content-history {
    overflow: auto;
  }
}
</style>


